<template>
    <div class="h100">
        <IScroll @loadBottom="loadMore" ref="scroll" id="scrollWrap" :empty="isEmpty">
            <slot name="title"></slot>
            <div class="mt10 ml5 mr5 mb10">
                <div class="goodInfoBoxList flexBetween">
                    <div class="indexGoodBlock_92fanli mb5 flexBox-cell-48"
                         v-for="(item,index) in list"
                         v-on:click="toGoodsDetail(item.sku_id)" :key="index">
                        <div class="ml5 mr5">
                            <ImageExt class="goodInfoBlockImg tc" :src="item.img_url"
                                      mode="aspectFit" />
                            <p class="goodBoxTitle mt5">{{item.goods_name}}</p>
                            <div class="flexBox flexBetween lh24">
                                <div class="f8"
                                     :class="{'color_green':styleName === 'main','color_red':styleName === 'main_b','color_yellow':styleName === 'main_c'}">￥<em
                                        class="f10">{{item.wl_unit_price}}</em></div>
                                <div class="f8 color_999">月销量{{item.in_order_count}}</div>
                            </div>
                            <div class="flexBox">
                                <div class="color_999 f8">京东价</div>
                                <div class="f8 color_999 ml5 txtTh">￥{{item.unit_price}}</div>
                            </div>
                            <div class="flexBox mt7 mb5">
                                <div v-if="item.reward_amount > 0">
                                    <div :class="{'voucherBlocks_92fanli':styleName === 'main','voucherBlocks_92fanli_red':styleName === 'main_b','voucherBlocks_92fanli_yellow':styleName === 'main_c'}">返{{item.reward_amount}}元</div>
                                </div>
                                <div v-else>
                                    <div :class="{'voucherBlocks_92fanli':styleName === 'main','voucherBlocks_92fanli_red':styleName === 'main_b','voucherBlocks_92fanli_yellow':styleName === 'main_c'}">无返利</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template slot="empty">
                <p class="tc mt12 noneImg"><img src="@/assets/images/orderNone.png" /></p>
                <p class="tc f10 color_999 lh24">暂无数据~</p>
            </template>
        </IScroll>
        <div class="goTopBtn">
            <img v-if="topStatus" src="@/assets/images/backTop.png" v-on:click="toTop">
        </div>
    </div>
</template>

<script>
    import IScroll from '../../components/IScroll';
    import ImageExt from '../../components/ImageExt';

    export default {
        components: {IScroll, ImageExt},
        props: {
            styleName: {
                type: String,
                default: 'main'
            },
            list: {
                type: Array
            },
            isMore: {
                type: Boolean,
                default: false
            },
            isEmpty: {
                type: Boolean,
                default: false
            },
            isTop: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                btnFlag: false
            }
        },
        computed: {
            topStatus() {
                return this.btnFlag && this.isTop;
            },
        },
        updated() {
            document.getElementById('scrollWrap').addEventListener('scroll', this.scrollToTop)
        },
        methods: {
            toGoodsDetail: function (id) {
                const route = {
                    name: 'jd-goods-detail',
                    query: {
                        id
                    }
                };
                this.$router.push(route);
            },
            loadMore: function () {
                this.$emit('loadMore', true);
            },
            scrollToTop: function () {
                this.btnFlag = document.getElementById('scrollWrap').scrollTop > 180;
                this.$emit('scrollToTop', document.getElementById('scrollWrap').scrollTop);
            },
            toTop: function (top) {
                document.getElementById('scrollWrap').scrollTop = top;
            }
        }
    }
</script>

<style scoped>

</style>
